import { ProtocolPractitioner } from "../../models/Entities/Protocols/ProtocolPractitioner";
import { CommonState } from "../common/state/commonState";
import { HcProtocolPatient } from '../../models/Entities/PractitionerAssociations/HcProtocolPatient';

export interface ProtocolPractitionersState
  extends CommonState<ProtocolPractitioner> {
  hcProtocolPatients: HcProtocolPatient[];
  isLoadingHcProtocolPatients: boolean;
  successLoadingHcProtocolPatients: boolean | undefined;
  failOnLoadingHcProtocolPatients: boolean;

  // export excel
  isExportingExcel: boolean;
  successExportingExcel: boolean | undefined;
  failOnExportingExcel: boolean;
}

export const ProtocolPractitionersUnloadState: any = {
    // loading all
    isLoadingAll: false,
    isLoadingAllSuccess: undefined,
    FailGettingAll: false,
    
    // loading one
    isLoadingOne: false,
    isLoadingOneSuccess: undefined,
    FailGettingOne: false,
    
    list: [],
    Selected: undefined,
    Error: undefined,

    // hc protocol patients
    hcProtocolPatients: [],
    isLoadingHcProtocolPatients: false,
    successLoadingHcProtocolPatients: undefined,
    failOnLoadingHcProtocolPatients: false,

    // export excel
    isExportingExcel: false,
    successExportingExcel: undefined,
    failOnExportingExcel: false
}